import LanguageValueList from "./LanguageValueList"; // Import LanguageValueList

export default class AdmsIdentifier {
  constructor(
    identifier_notation = "",
    creator = new LanguageValueList(), // Change this to LanguageValueList
    id = "",
  ) {
    this.identifier_notation = identifier_notation;
    this.creator = creator;  // Should be an instance of LanguageValueList
    this.id = id;
  }

  // Getters and Setters
  getIdentifierNotation() {
    return this.identifier_notation;
  }

  setIdentifierNotation(identifier_notation) {
    this.identifier_notation = identifier_notation;
  }

  getCreator() {
    return this.creator;
  }

  setCreator(creator) {
    if (creator instanceof LanguageValueList) { // Check for LanguageValueList
      this.creator = creator;
    } else {
      throw new Error("Creator must be an instance of LanguageValueList");
    }
  }

  getId() {
    return this.id;
  }

  setId() {
    return this.id;
  }

  toJSON() {
    return {
      identifier_notation: this.identifier_notation,
      id: this.id,
      creator: this.creator.toJSON(), // Call toJSON on LanguageValueList
    };
  }
}
